import React from 'react'
import styles from './CommunityItem.module.scss'
import { URL } from '../../../constants/content'
import classNames from 'classnames'
import { ReactComponent as StarSVG } from './StarSVG.svg'
import { ReactComponent as GitHubSVG } from './GitHubSVG.svg'
import { ReactComponent as DiscordSVG } from './DiscordSVG.svg'
import { kFormatter } from '../../../helpers/format'

function CommunityItem({ stars, isDarkMode }: { stars?: number; isDarkMode?: boolean }) {
  return (
    <div className={classNames(styles.container, { [styles.darkContainer]: isDarkMode })}>
      <a href={URL.discordServerURL} className={styles.discord}>
        <div className={styles.discordPill}>
          <DiscordSVG />
          <span>Discord</span>
        </div>
      </a>
      <a href={URL.githubRepoUrl} className={styles.github}>
        <div className={styles.githubPill}>
          <GitHubSVG />
          <span>GitHub</span>
        </div>
        <span className={styles.githubStars}>
          <StarSVG className={styles.star} />
          {stars ? `${kFormatter(stars, true)}+` : '...'}
        </span>
      </a>
    </div>
  )
}

export default CommunityItem
